// extracted by mini-css-extract-plugin
export default {"table":"table___w3VGH","row":"row___wun5C"};